import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { styled } from '@stitches/react';
import MiningHotelOverview from './MiningHotelOverview';
import MiningHotelServices from './MiningHotelServices';
import MiningHotelFacilities from './MiningHotelFacilities';
import MiningHotelApplication from './MiningHotelApplication';
import MiningHotelCalculator from './MiningHotelCalculator';
import MiningHotelFaq from './MiningHotelFaq';

// 矿机托管页面容器
const MiningHotelContainer = styled('div', {
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 1rem'
});

/**
 * 矿机托管组件
 * 提供ASIC矿机托管服务及相关功能的路由
 */
const MiningHotel: React.FC = () => {
  // const { t } = useTranslation(); // 暂时未使用
  
  return (
    <MiningHotelContainer>
      <Routes>
        {/* 矿机托管概览页面 */}
        <Route index element={<MiningHotelOverview />} />
        
        {/* 托管服务页面 */}
        <Route path="services" element={<MiningHotelServices />} />
        
        {/* 矿场设施页面 */}
        <Route path="facilities" element={<MiningHotelFacilities />} />
        
        {/* 托管申请页面 */}
        <Route path="application" element={<MiningHotelApplication />} />
        
        {/* 价格计算器页面 */}
        <Route path="calculator" element={<MiningHotelCalculator />} />
        
        {/* 常见问题页面 */}
        <Route path="faq" element={<MiningHotelFaq />} />
        
        {/* 重定向到矿机托管概览 */}
        <Route path="*" element={<Navigate to="/products/mining-hotel" replace />} />
      </Routes>
    </MiningHotelContainer>
  );
};

export default MiningHotel; 